import { render, staticRenderFns } from "./AddSalaryForm.vue?vue&type=template&id=62f79e46"
import script from "./AddSalaryForm.vue?vue&type=script&lang=js"
export * from "./AddSalaryForm.vue?vue&type=script&lang=js"
import style0 from "./AddSalaryForm.vue?vue&type=style&index=0&id=62f79e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports